import { IEditor } from './types';

interface IEditorList {
  Code: IEditor;
  WebForm: IEditor;
}

export const EDITOR: IEditorList = {
  Code: {
    key: 'editors:code',
    config: { language: '4d', theme: 'fd-dark' },
  },
  WebForm: {
    key: 'editors:webforms',
  },
};
